export default __webpack_public_path__ + "static/media/110.5a0cb18c.png";